export const osanoStyles = {
  ".osano-cm-widget": {
    display: "none",
  },
  ".osano-cm-window__dialog": {
    textStyle: "base",
    color: "fg.default",
    backgroundColor: "highlight.subtle",
    borderTop: "1px solid",
    borderTopColor: "border.container",
    padding: "16px 40px",
    overflowY: "hidden",
    justifyContent: "space-between",
    gap: { sm: "0", md: "32px" },
  },
  ".osano-cm-link": {
    color: "highlight.fg",
    "&:hover, &:active, &:focus": {
      color: "highlight.fg",
    },
  },
  ".osano-cm-button": {
    borderRadius: "sm",
    border: "transparent",
  },
  ".osano-cm-button:hover": {
    backgroundColor: "button.emphasized",
  },
  ".osano-cm-buttons__button": {
    textStyle: "buttonM",
    maxWidth: { sm: "unset !important", md: "300px" },
    width: "100% !important",
    margin: "0 !important",
    color: "fg.inverted",
    backgroundColor: "button.solid",
    outline: "0",
    border: "none",
    borderRadius: "sm",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "button.emphasized",
    },
  },
  ".osano-cm-buttons__button:not(:first-of-type)": {
    color: "fg.default",
    backgroundColor: "transparent",
    border: "1px solid",
    borderColor: "button.solid",
    "&:hover": {
      backgroundColor: "button.default",
    },
  },
  ".osano-cm-dialog--type_bar": {
    ".osano-cm-dialog__content": {
      marginBottom: 0,
      maxWidth: "100%",
    },
  },
  ".osano-cm-dialog__buttons": {
    justifyContent: "center",
    flexWrap: "nowrap",
    gap: "2",
    maxWidth: "unset !important",
    marginLeft: "32px !important",
    flexDirection: "column",
    minWidth: { md: "unset !important", lg: "initial" },
    flex: { md: "unset", lg: "default" },
    width: { sm: "100% !important", md: "initial" },
    alignItems: { sm: "center", md: "initial" },
    margin: { sm: "unset !important", md: "initial" },
    borderRadius: "99px",
  },
  ".osano-cm-dialog__content": {
    maxWidth: { sm: "100%", md: "65%" },
    flex: { sm: "initial", md: "3 !important" },
    paddingBottom: { sm: "16px", md: "initial" },
    textAlign: { sm: "center", md: "start" },
    "& > span": {
      display: { sm: "block", md: "initial" },
      padding: { sm: "0", md: "initial" },
      margin: { sm: "0", md: "initial" },
    },
  },
  ".osano-cm-window__widget": {
    display: "none",
  },
  ".osano-cm-dialog__close": {
    transform: "none",
    transition: "none",
    marginRight: "8px",
    marginTop: "8px",
    stroke: "fg.default",
    "&:focus": {
      stroke: "fg.emphasized",
      backgroundColor: "transparent !important",
      borderColor: "transparent !important",
      strokeWidth: "1px",
    },
    "&:hover": {
      stroke: "var(--chakra-colors-fg-emphasized) !important",
      strokeWidth: "1px",
    },
  },
  ".osano-cm-info-dialog-header__close": {
    transform: "none",
    transition: "none",
    "&:focus": {
      backgroundColor: "transparent",
      borderColor: "transparent",
      stroke: "fg.emphasized",
      strokeWidth: "1px",
    },
    "&:hover": {
      stroke: "var(--chakra-colors-fg-emphasized) !important",
      strokeWidth: "1px",
    },
  },
  ".osano-cm-toggle__switch": {
    backgroundColor: "neutral.muted",
    "&::after": {
      backgroundColor: "bg.container",
    },
    "&:focus": {
      border: "none",
    },
  },
  ".osano-cm-toggle__input:disabled:checked + .osano-cm-toggle__switch": {
    backgroundColor: "highlight.muted",
    borderColor: "highlight.solid",
    "&::after": {
      backgroundColor: "bg.container",
    },
  },
  ".osano-cm-toggle__input:disabled:checked + .osano-cm-toggle__switch, .osano-cm-toggle__input:disabled:checked:hover + .osano-cm-toggle__switch, .osano-cm-toggle__input:disabled:checked:active + .osano-cm-toggle__switch, .osano-cm-toggle__input:disabled:checked:focus + .osano-cm-toggle__switch":
    {
      background: "highlight.muted",
      borderColor: "highlight.solid",
    },
  ".osano-cm-toggle__input:checked + .osano-cm-toggle__switch, .osano-cm-toggle__input:checked:hover + .osano-cm-toggle__switch, .osano-cm-toggle__input:checked:active + .osano-cm-toggle__switch, .osano-cm-toggle__input:checked:focus + .osano-cm-toggle__switch":
    {
      background: "highlight.solid",
      borderColor: "highlight.solid",
    },
  ".osano-cm-toggle__input:checked + .osano-cm-toggle__switch": {
    backgroundColor: "highlight.solid",
    borderColor: "highlight.solid",
  },
  ".osano-cm-toggle__input:disabled:checked:focus + .osano-cm-toggle__switch": {
    "&::after": {
      backgroundColor: "bg.container",
    },
  },
  ".osano-cm-toggle__input:disabled:checked:hover + .osano-cm-toggle__switch": {
    "&::after": {
      backgroundColor: "bg.container",
    },
  },
  ".osano-cm-toggle__input + .osano-cm-toggle__switch": {
    backgroundColor: "neutral.muted",
    borderColor: "neutral.muted",
  },
  ".osano-cm-toggle__input:focus + .osano-cm-toggle__switch::before": {
    borderColor: "transparent !important",
  },
  ".osano-cm-toggle__label": {
    textStyle: "baseBold",
  },
  ".osano-cm-view__button": {
    textStyle: "buttonM",
    background: "button.solid",
    color: "fg.inverted",
    "&:hover": {
      background: "button.emphasized",
    },
  },
  ".osano-cm-description": {
    textStyle: "base",
    color: "fg.emphasized",
  },
  ".osano-cm-info-dialog-header__header": {
    fontSize: "20px",
    lineHeight: "24px",
    color: "fg.default",
    fontWeight: "700",
  },
  ".osano-cm-disclosure__toggle": {
    color: "highlight.fg",
    "&:focus": {
      color: "highlight.fg",
    },
    "&:hover": {
      color: "highlight.fg",
    },
    "&:active": {
      color: "highlight.fg",
    },
  },
  ".osano-cm-expansion-panel__toggle": {
    "&:hover": {
      color: "highlight.fg",
    },
    "&:active": {
      color: "highlight.fg",
    },
  },
};
